import React from 'react';

import cn from 'classnames';

import { DotSpin } from '../../../../shared/components/dot-spin';
import ParticipantIcon from '../../../../shared/components/participant-icon';
import css from './index.css';

interface Props {
    userId: string;
    isVideoOn: boolean;
    uid?: string;
    small?: boolean;
    isPending?: boolean;
    className?: string;
}

export const ParticipantAvatar: React.FC<Props> = (props) => {
    const { userId, isVideoOn, uid, small, isPending, className } = props;

    return (
        <div
            className={cn(css.AvatarBlock, className, {
                [css.AvatarBlock_small]: small,
            })}
        >
            {!isVideoOn ? (
                <div
                    className={cn(css.Avatar, {
                        [css.Avatar_isPending]: isPending,
                    })}
                >
                    <ParticipantIcon
                        placeholderStyle={{ height: '100%', width: 'auto' }}
                        participantId={userId}
                        uid={uid}
                        className={css.participantIcon}
                    />
                    {isPending && <DotSpin className={css.Avatar__pendingIndicator} />}
                </div>
            ) : null}
        </div>
    );
};
